import React from 'react';
import {
  JobSubStatusFilter,
  COMPLETED_STATUS_FILTERS,
  ASSIGNED_STATUS_FILTERS,
  ALL_STATUS_FILTERS
} from 'components/common/Tables';

const StatusFilters = {
    'Completed Jobs' : COMPLETED_STATUS_FILTERS,
    'Assigned Orders' : ASSIGNED_STATUS_FILTERS,
    'All Orders' : ALL_STATUS_FILTERS,
}

export function SubJobStatusFilter(title, tempFilters, setTempFilters) {
  if (Object.keys(StatusFilters).includes(title)) {
    return <div>
    <JobSubStatusFilter
      filters={tempFilters}
      setFilters={setTempFilters}
      options={StatusFilters[title]}
    />
  </div>
  }
};

export default SubJobStatusFilter;


// WEBPACK FOOTER //
// ./src/pages/Orders/SubJobStatusFilter.jsx